import { createRouter, createWebHistory } from 'vue-router'
import { navigationConfig } from '@/config/navigation-config'

// Генерация маршрутов из navigationConfig
const routes = navigationConfig
	.filter(item => item.path && item.component) // Только элементы с путём и компонентом
	.map(item => ({
		path: item.path,
		name: item.name,
		component: item.component,
		meta: { roles: item.roles }
	}))

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes
})

// Навигационный охранник
router.beforeEach(async (to, from, next) => {
	// Публичные страницы, не требующие авторизации
	const publicPages = ['/login', '/register', '/info']
	const authRequired = !publicPages.includes(to.path)
	const loggedIn = localStorage.getItem('user')
		? JSON.parse(localStorage.getItem('user')).login
		: false
	const user = localStorage.getItem('user')
		? JSON.parse(localStorage.getItem('user'))
		: null
	const userRole = user?.role // Предполагается, что роль хранится в объекте user

	// Обработка параметра ref
	if (to.query.ref) {
		localStorage.setItem('ref', to.query.ref)
		const newPath = {
			path: to.path,
			query: { ...to.query, ref: undefined } // Удаляем ref из query
		}
		return next(newPath)
	}

	// Проверка авторизации
	if (authRequired && !loggedIn) {
		return next('/login')
	}

	// Проверка ролей
	const requiredRoles = to.meta.roles || []
	if (requiredRoles.length === 0) {
		return next() // Доступ разрешён всем
	}

	if (!userRole) {
		return next('/login') // Если нет роли, перенаправляем на логин
	}

	if (requiredRoles.includes(userRole)) {
		return next() // Роль подходит, доступ разрешён
	} else {
		return next('/') // Роль не подходит, перенаправляем на главную
	}
})

export default router
